import { useTheme } from 'lib/context/ThemeContext';

const IconTwitter = (): JSX.Element => {
  const { themeName } = useTheme();
  return themeName === 'aw' ? (
    <svg
      role="img"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Twitter Icon</title>
      <path
        d="M8.20312 0C3.78527 0 0.203125 3.58214 0.203125 8C0.203125 12.4179 3.78527 16 8.20312 16C12.621 16 16.2031 12.4179 16.2031 8C16.2031 3.58214 12.621 0 8.20312 0ZM12.0478 6.03036C12.0531 6.11429 12.0531 6.20179 12.0531 6.2875C12.0531 8.90893 10.0567 11.9286 6.40848 11.9286C5.28348 11.9286 4.24062 11.6018 3.36205 11.0393C3.52277 11.0571 3.67634 11.0643 3.84063 11.0643C4.7692 11.0643 5.62277 10.75 6.30313 10.2179C5.4317 10.2 4.69955 9.62857 4.44955 8.84286C4.75491 8.8875 5.02991 8.8875 5.3442 8.80714C4.89549 8.71598 4.49219 8.47229 4.2028 8.11747C3.91341 7.76265 3.75578 7.31858 3.7567 6.86071V6.83571C4.0192 6.98393 4.32813 7.075 4.65134 7.0875C4.37963 6.90642 4.1568 6.66109 4.00261 6.37327C3.84842 6.08544 3.76763 5.76402 3.76741 5.4375C3.76741 5.06786 3.86384 4.73036 4.03705 4.4375C4.53509 5.0506 5.15657 5.55204 5.8611 5.90922C6.56562 6.26641 7.33743 6.47135 8.12634 6.51071C7.84598 5.1625 8.85313 4.07143 10.0638 4.07143C10.6353 4.07143 11.1496 4.31071 11.5121 4.69643C11.9603 4.6125 12.3888 4.44464 12.771 4.21964C12.6228 4.67857 12.3121 5.06607 11.8996 5.31071C12.2996 5.26786 12.6853 5.15714 13.0424 5.00179C12.7728 5.39821 12.4353 5.75 12.0478 6.03036Z"
        fill="currentColor"
      />
    </svg>
  ) : (
    <svg
      role="img"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Twitter Icon</title>
      <path
        d="M16 0C7.16429 0 0 7.16429 0 16C0 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16429 24.8357 0 16 0ZM23.6893 12.0607C23.7 12.2286 23.7 12.4036 23.7 12.575C23.7 17.8179 19.7071 23.8571 12.4107 23.8571C10.1607 23.8571 8.075 23.2036 6.31786 22.0786C6.63929 22.1143 6.94643 22.1286 7.275 22.1286C9.13214 22.1286 10.8393 21.5 12.2 20.4357C10.4571 20.4 8.99286 19.2571 8.49286 17.6857C9.10357 17.775 9.65357 17.775 10.2821 17.6143C9.38474 17.432 8.57813 16.9446 7.99934 16.2349C7.42056 15.5253 7.10531 14.6372 7.10714 13.7214V13.6714C7.63214 13.9679 8.25 14.15 8.89643 14.175C8.35301 13.8128 7.90735 13.3222 7.59897 12.7465C7.29059 12.1709 7.12901 11.528 7.12857 10.875C7.12857 10.1357 7.32143 9.46071 7.66786 8.875C8.66394 10.1012 9.9069 11.1041 11.3159 11.8184C12.725 12.5328 14.2686 12.9427 15.8464 13.0214C15.2857 10.325 17.3 8.14286 19.7214 8.14286C20.8643 8.14286 21.8929 8.62143 22.6179 9.39286C23.5143 9.225 24.3714 8.88929 25.1357 8.43929C24.8393 9.35714 24.2179 10.1321 23.3929 10.6214C24.1929 10.5357 24.9643 10.3143 25.6786 10.0036C25.1393 10.7964 24.4643 11.5 23.6893 12.0607V12.0607Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconTwitter;
